(() => {
  const track = (eventName, payload = {}) => {
    try {
      window.Shopify?.analytics?.publish(eventName, payload);
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...payload });
    } catch (_) {}
  };
  const pageType = document.body.dataset.template || 'other';
  if (pageType === 'product' && !document.documentElement.dataset.rspProductViewTracked) {
    document.documentElement.dataset.rspProductViewTracked = 'true';
    track('roadspec_product_detail_viewed', {
      product_id: document.querySelector('[data-product-id]')?.dataset.productId || '',
    });
  }
  const dialog = document.querySelector('[data-rsp-lead-dialog]');
  const leadTriggers = document.querySelectorAll('[data-rsp-lead-trigger], [data-rsp-open-lead]');
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch (_) {} },
  };

  if (dialog && typeof dialog.showModal === 'function') {
    const success = Boolean(dialog.querySelector('[data-rsp-lead-success]'));
    const hasErrors = Boolean(dialog.querySelector('.errors'));
    const subscribed = storage.get('rsp_lead_subscribed') === '1';
    const dismissedAt = Number(storage.get('rsp_lead_dismissed_at') || 0);
    const dismissedRecently = Date.now() - dismissedAt < 30 * 24 * 60 * 60 * 1000;
    let opened = false;
    let eligible = false;

    const open = () => {
      if (opened || dialog.open || (subscribed && !success)) return;
      opened = true;
      dialog.showModal();
      track('roadspec_lead_opened', { page_type: dialog.dataset.pageType || 'other' });
      window.setTimeout(() => dialog.querySelector('input[type="email"]')?.focus(), 50);
    };
    const dismiss = () => {
      storage.set('rsp_lead_dismissed_at', String(Date.now()));
      if (dialog.open) dialog.close();
    };

    dialog.querySelectorAll('[data-rsp-lead-close]').forEach((button) => button.addEventListener('click', dismiss));
    dialog.querySelector('form')?.addEventListener('submit', () => {
      track('roadspec_lead_submitted', { page_type: dialog.dataset.pageType || 'other' });
    });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dismiss(); });
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
    leadTriggers.forEach((trigger) => trigger.addEventListener('click', () => { opened = false; open(); }));
    if (subscribed && !success) leadTriggers.forEach((trigger) => trigger.setAttribute('hidden', 'hidden'));

    if (success || new URLSearchParams(location.search).get('customer_posted') === 'true') {
      storage.set('rsp_lead_subscribed', '1');
      leadTriggers.forEach((trigger) => trigger.setAttribute('hidden', 'hidden'));
      open();
    } else if (hasErrors) {
      open();
    } else if (!subscribed && !dismissedRecently && dialog.dataset.autoShow === 'true') {
      const delay = Number(dialog.dataset.delay || 25000);
      window.setTimeout(() => { eligible = true; }, Math.min(delay, 12000));
      window.setTimeout(open, delay);
      let depthTriggered = false;
      window.addEventListener('scroll', () => {
        if (!depthTriggered && eligible && window.scrollY > document.documentElement.scrollHeight * 0.42) {
          depthTriggered = true;
          open();
        }
      }, { passive: true });
      document.addEventListener('mouseout', (event) => {
        if (eligible && window.innerWidth >= 990 && !event.relatedTarget && event.clientY <= 0) open();
      });
    }
  }

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-rsp-open-chat]');
    if (!target) return;
    track('roadspec_chat_opened', { page_type: document.body.dataset.template || 'other' });
  });

  const trackedDepths = new Set();
  const trackDepth = () => {
    const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    const percent = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
    [25, 50, 75].forEach((depth) => {
      if (percent >= depth && !trackedDepths.has(depth)) {
        trackedDepths.add(depth);
        track('roadspec_scroll_depth', { depth_percent: depth, page_type: pageType });
      }
    });
  };
  window.addEventListener('scroll', trackDepth, { passive: true });
  [15, 30].forEach((seconds) => window.setTimeout(() => {
    if (document.visibilityState === 'visible') {
      track('roadspec_engaged_time', { seconds, page_type: pageType });
    }
  }, seconds * 1000));

  const originalFetch = window.fetch?.bind(window);
  if (originalFetch && !window.__roadSpecFetchTracked) {
    window.__roadSpecFetchTracked = true;
    window.fetch = async (...args) => {
      const requestUrl = String(args[0]?.url || args[0] || '');
      const isCartAdd = /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(requestUrl);
      try {
        const response = await originalFetch(...args);
        if (isCartAdd) {
          track(response.ok ? 'roadspec_add_to_cart_succeeded' : 'roadspec_add_to_cart_failed', {
            http_status: response.status,
            page_type: pageType,
            product_id: document.querySelector('[data-product-id]')?.dataset.productId || '',
          });
        }
        return response;
      } catch (error) {
        if (isCartAdd) {
          track('roadspec_add_to_cart_failed', {
            error_type: 'network_error',
            page_type: pageType,
            product_id: document.querySelector('[data-product-id]')?.dataset.productId || '',
          });
        }
        throw error;
      }
    };
  }

  const recentSearchesKey = 'roadspec_recent_searches_v1';
  const saveRecentSearch = (query) => {
    const clean = String(query || '').replace(/\s+/g, ' ').trim();
    if (clean.length < 2) return;
    try {
      const current = JSON.parse(localStorage.getItem(recentSearchesKey) || '[]');
      const next = [clean, ...(Array.isArray(current) ? current : []).filter((item) => item !== clean)].slice(0, 5);
      localStorage.setItem(recentSearchesKey, JSON.stringify(next));
    } catch (_) {}
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[role="search"]');
    if (form) {
      const query = form.querySelector('input[name="q"]')?.value || '';
      saveRecentSearch(query);
      track('roadspec_search_submitted', {
        query_length: query.trim().length,
        page_type: pageType,
      });
    }

    const productForm = event.target.closest('form[data-type="add-to-cart-form"]');
    if (productForm) {
      track('roadspec_add_to_cart_submitted', {
        page_type: pageType,
        product_id: document.querySelector('[data-product-id]')?.dataset.productId || '',
      });
    }
  });

  document.addEventListener('click', (event) => {
    const mediaTarget = event.target.closest('.product__media-toggle, .thumbnail');
    if (mediaTarget) {
      track('roadspec_product_image_opened', {
        media_id: mediaTarget.dataset.mediaId || mediaTarget.closest('[data-target]')?.dataset.target || '',
        page_type: document.body.dataset.template || 'other',
      });
    }

    const copyReference = event.target.closest('[data-rsp-copy-reference]');
    if (copyReference) {
      const reference = copyReference.dataset.rspCopyReference || '';
      if (reference && navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(reference).then(() => {
          const originalLabel = copyReference.textContent;
          copyReference.textContent = 'Copied';
          window.setTimeout(() => { copyReference.textContent = originalLabel; }, 1600);
        }).catch(() => {});
      }
      track('roadspec_reference_copied', { page_type: pageType, has_reference: Boolean(reference) });
    }

    const cardLink = event.target.closest('.rsp-fitment-grid .card-wrapper a[href*="/products/"]');
    if (cardLink && !cardLink.dataset.rspTrackedClick) {
      cardLink.dataset.rspTrackedClick = 'true';
      track('roadspec_product_card_clicked', {
        product_handle: cardLink.href.split('/products/')[1]?.split(/[?#/]/)[0] || '',
        page_type: document.body.dataset.template || 'other',
      });
    }

    const checkout = event.target.closest('[data-rsp-checkout]');
    if (checkout) {
      const confirmationTarget = checkout.dataset.rspConfirmationTarget ? document.getElementById(checkout.dataset.rspConfirmationTarget) : checkout.closest('[data-rsp-cart-confirmation]');
      const confirmation = confirmationTarget?.querySelector('[data-rsp-fitment-confirmation]');
      track('roadspec_checkout_started', {
        item_count: document.querySelectorAll('[data-rsp-cart-fitment-item]').length,
        fitment_reviewed: confirmation ? Boolean(confirmation.checked) : null,
        page_type: pageType,
      });
    }

    const trustLink = event.target.closest('.rsp-purchase-proof a, .rsp-order-process__track a');
    if (trustLink) {
      track('roadspec_purchase_information_opened', {
        destination: trustLink.getAttribute('href') || '',
        page_type: pageType,
      });
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('#SortBy, .facet-filters__sort')) {
      track('roadspec_search_sort_changed', {
        sort_by: event.target.value,
        page_type: pageType,
      });
    }
    if (event.target.matches('[data-rsp-fitment-confirmation]') && event.target.checked) {
      track('roadspec_cart_fitment_confirmed', {
        item_count: document.querySelectorAll('[data-rsp-cart-fitment-item]').length,
        page_type: pageType,
      });
    }
  });

  document.addEventListener('toggle', (event) => {
    if (event.target.matches('[data-rsp-product-fitment]') && event.target.open) {
      track('roadspec_fitment_details_opened', { page_type: pageType });
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-rsp-vehicle-context-toggle]')) {
      track('roadspec_vehicle_selector_opened', { page_type: pageType });
    }
  });
})();
